import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from '../../app/store';
import {ThemeName} from '../../common/styles/themes/models';
import {getTheme} from '../../common/styles/themes';

interface IThemeState {
  theme: ThemeName;
}

const initialState: IThemeState = {
  theme: ThemeName.ExcelsiorFresh,
};

const themeStateSlice = createSlice({
  name: 'themeState',
  initialState,
  reducers: {
    setThemeName: (state, action: PayloadAction<ThemeName>) => {
      state.theme = action.payload;
    },
  },
});

export const {setThemeName} = themeStateSlice.actions;

export const selectThemeName = (state: RootState) => state.themeState.theme;
export const selectTheme = (state: RootState) => getTheme(state.themeState.theme);

export default themeStateSlice.reducer;
